import httpClient from '../lib/http-client'

const appDataApi = {
  findCompanies () {
    return httpClient.get('/app-data/companies')
  },
  findCallingCodes () {
    return httpClient.get('/app-data/calling-codes')
  },
  findRules (wcagVersion = '2.1') {
    return httpClient.get(`/app-data/rules/${wcagVersion || ''}`)
  },
  authStatus () {
    return httpClient.post('/app-data/auth-status', {})
  }
}

export default appDataApi



// WEBPACK FOOTER //
// ./src/api/app-data.js